import React, { useEffect, useMemo, useState } from "react";
import { Card, Form, Table } from "react-bootstrap";
import usePalette from "../../../../hooks/usePalette";
import { useDispatch, useSelector } from "react-redux";
import numeral from "numeral";
import { IconButton, Tooltip } from "@mui/material";
import CurrencyInput from "react-currency-input-field";
import Select, { components } from "react-select";
import { customStylesForm } from "../../../../components/common/customStyleSelect";

// Icons
import Icon from "@mdi/react";
import { mdiPlusCircle, mdiMinusCircle } from "@mdi/js";

import {
  // addScopeProject,
  createCertifyFinancial,
  removeScopeProject,
  updateRevisedProjectScope,
} from "../../../../redux/slices/utilsSlice";
import {
  addNewProjectScope,
  deleteNewProjectScope,
  updateNewProjectScope,
} from "../../../../redux/slices/certify/projectsSlice";

const OriginalScopeProject = () => {
  const dispatch = useDispatch();
  const palette = usePalette();

  const { project } = useSelector((state) => ({
    project: state.certifyReducer.project.data,
  }));

  const {
    originalCost,
    originalCeiling,
    originalProjectScope,
    originalScopeByYear,
  } = useMemo(() => {
    const originalApplication = project?.project_profile_stages?.find(
      (obj) => obj?.status === 2 && obj?.stages === 4,
    );
    const scope = originalApplication?.original_project_scope || [];

    const cost = scope?.reduce(
      (acc, obj) => acc + (parseFloat(obj.cost_required) || 0),
      0,
    );

    const ceiling = scope.reduce(
      (acc, obj) => acc + (parseFloat(obj.ceiling) || 0),
      0,
    );

    const groupedByYear = scope
      ?.flatMap((obj) =>
        obj.ceiling_flow_details.map((subObj) => ({
          ...subObj,
          cost_description: obj.cost_description,
        })),
      )
      ?.reduce((acc, item) => {
        const { year } = item;

        if (!acc[year]) {
          acc[year] = [];
        }

        acc[year].push(item);
        return acc;
      }, {});

    const scopeCeilingFlow = Object.keys(groupedByYear).map((year) => ({
      year: parseInt(year), // Convert year string to number
      children: groupedByYear[year],
    }));

    return {
      originalCost: cost,
      originalCeiling: ceiling,
      originalProjectScope: scope,
      originalScopeByYear: scopeCeilingFlow,
    };
  }, [project]);

  useEffect(() => {
    if (project) {
      const newValues = project.financial_details?.map((obj) => {
        return {
          ...obj,
          ceiling_flow_details: obj.ceiling_flow_details.map((subObj) => ({
            ...subObj,
            cost_description: obj.cost_description,
          })),
        };
      });
      dispatch(createCertifyFinancial(newValues));
    }
  }, [dispatch, project]);

  return (
    <>
      <Card>
        {/* Original Project Scope */}
        <Card.Body>
          <div className='mb-3'>
            <h5>SENARAI ASAL SKOP PROJEK YANG DIPOHON</h5>
          </div>
          <div className='table-responsive'>
            <Table bordered size='sm' style={{ fontSize: 11, width: "100%" }}>
              <thead className='text-center align-middle custom-table-head'>
                <tr>
                  <th style={{ width: "3%" }}>BIL.</th>
                  <th>KOMPONEN PROJEK</th>
                  <th>KESELURUHAN KOS DIPOHON (RM)</th>
                  <th>KESELURUHAN SILING DIPOHON (RM)</th>
                </tr>
              </thead>
              <tbody className='text-uppercase' style={{ fontWeight: 500 }}>
                {originalProjectScope?.map((obj, idx) => {
                  return (
                    <tr key={obj.id}>
                      <td className='text-center'>{idx + 1}.</td>
                      <td>{obj.cost_description}</td>
                      <td className='text-end pe-2'>
                        {numeral(obj.cost_required).format("0,0.00")}
                      </td>
                      <td className='text-end pe-2'>
                        {numeral(obj.ceiling).format("0,0.00")}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={2} className='text-end pe-2'>
                    JUMLAH KESELURUHAN (ASAL)
                  </td>
                  <td className='text-end pe-2'>
                    {numeral(originalCost).format("0,0.00")}
                  </td>
                  <td className='text-end pe-2'>
                    {numeral(originalCeiling).format("0,0.00")}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className='my-3'>
            <h5>SENARAI ASAL ALIRAN SILING</h5>
          </div>
          <div className='table-responsive'>
            <Table bordered size='sm' style={{ fontSize: 11, width: "100%" }}>
              <thead className='text-center align-middle custom-table-head'>
                <tr>
                  <th style={{ width: "3%" }}>BIL.</th>
                  <th>KOMPONEN PROJEK</th>
                  <th>SILING DIPOHON (RM)</th>
                </tr>
              </thead>
              <tbody className='text-uppercase' style={{ fontWeight: 500 }}>
                {originalScopeByYear?.map((obj, idx) => {
                  const totalCeilingByYear = obj.children.reduce(
                    (acc, item) => acc + parseFloat(item.amount) || 0,
                    0,
                  );
                  return (
                    <React.Fragment key={idx}>
                      <tr
                        style={{ backgroundColor: "#eceff1", fontWeight: 700 }}
                      >
                        <td className='text-center'>{idx + 1}</td>
                        <td colSpan={3}>TAHUN {obj.year}</td>
                      </tr>
                      {obj?.children.map((subObj, subIdx) => {
                        return (
                          <tr key={subIdx}>
                            <td className='text-center'>
                              {idx + 1}.{subIdx + 1}
                            </td>
                            <td>{subObj.cost_description}</td>
                            <td className='text-end pe-2'>
                              {numeral(subObj.amount).format("0,0.00")}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={2} className='text-end pe-2'>
                          JUMLAH TAHUN {obj.year}
                        </td>
                        <td className='text-end pe-2'>
                          {numeral(totalCeilingByYear).format("0,0.00")}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
                <tr>
                  <td colSpan={2} className='text-end pe-2'>
                    JUMLAH SILING KESELURUHAN (ASAL)
                  </td>
                  <td className='text-end pe-2'>
                    {numeral(originalCeiling).format("0,0.00")}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default OriginalScopeProject;
